import {
	Model,
	SafetyNearMissReportType,
	User
} from ".";

export default class SafetyNearMissReport extends Model {
	get singularNoun() {
		return "near miss report";
	}

	get mutations() {
		return {
			reportType: SafetyNearMissReportType,
			employeesInvolved: User,
			supervisor: User
		};
	}

	get employeesInvolvedNames() {
		if ( this.employeesInvolved && this.employeesInvolved.length ) {
			return this.employeesInvolved.map( employee => employee.name ).join( ", " );
		}
	}

	get completed() {
		return Boolean( this.completedDate );
	}

	resource() {
		return "safety/near-miss-reports";
	}
}
